import api from '@/services/api'
import DefaulticonActions from './actions-types'

export default {
  [DefaulticonActions.GET_ALL_DEFAULTICONS]({}, options) {
    return new Promise((resolve, reject) => {
      api.node.defaulticon
        .getDefaulticons(options)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('Store action error:', error)
          reject(error)
        })
    })
  },

  [DefaulticonActions.SAVE_DEFAULTICON]({ state }) {
    return new Promise((resolve, reject) => {
      let data = {}
      state.fields.forEach((item) => {
        data[item.name] = item.value
      })

      if (state.selectedDefaulticon && state.selectedDefaulticon.default_icon_id) {
        api.node.defaulticon
          .updateDefaulticon(data, state.selectedDefaulticon.default_icon_id)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      } else {
        api.node.defaulticon
          .createDefaulticon(data)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      }
    })
  },

  [DefaulticonActions.UPDATE_DEFAULTICON]({ state }, data) {
    return new Promise((resolve, reject) => {
      api.node.defaulticon
        .updateDefaulticon(data, state.selectedDefaulticon.default_icon_id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  },

  [DefaulticonActions.DELETE_DEFAULTICON]({}, defaulticonId) {
    return new Promise((resolve, reject) => {
      api.node.defaulticon
        .deleteDefaulticon(defaulticonId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  },

  [DefaulticonActions.GET_DEFAULTICON]({}, defaulticonId) {
    return new Promise((resolve, reject) => {
      api.node.defaulticon
        .getDefaulticon(defaulticonId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  }
}
